'use client';

import { useCookies } from '@packages/shared/src/providers/CookieProvider/CookieProvider';
import { SearchScrollTopButton } from '@packages/search/src/components/SearchScrollTopButton/SearchScrollTopButton';
import { SearchScrollTopAutoHideButton } from '@packages/search/src/components/SearchScrollTopAutoHideButton/SearchScrollTopAutoHideButton';
import { hasFeatureFlag } from '@packages/search/src/utils/featureFlags/hasFeatureFlag';
import { filterSettingsFab } from '@packages/search/src/activeFeatureFlags';

export const SearchScrollTopButtonClient = () => {
  const { getCookies } = useCookies();
  const hasFilterSettingsFab = hasFeatureFlag(filterSettingsFab, getCookies());

  return hasFilterSettingsFab ? <SearchScrollTopAutoHideButton /> : <SearchScrollTopButton />;
};
